import { itx } from "../../../src/translationItx/itx";
import React from "react";
import { ChannelType } from "../types/C1_EloTypes";
import { C1_TagFunction } from "./C1_TagFunction";

/** Shows a compact light function above its tag, with a separate DALI badge. */
export function C1_LightTagFunction({ x, y, channelType, isDali, color, badgeColor }: {
  x: number;
  y: number;
  channelType: ChannelType | undefined;
  isDali: boolean;
  color: string;
  badgeColor: string;
}) {
  let label: string | undefined;
  switch (channelType) {
    case ChannelType.Dimmer: label = "%"; break;
    case ChannelType.TuneableWhite: label = itx("toolBar.twShortTag", "TW"); break;
    case ChannelType.Rgb: label = "RBG"; break;
  }
  const textStyle = {
    fill: color,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 4.1,
    fontWeight: 400,
    textAnchor: "middle" as const,
    dominantBaseline: "central" as const,
    alignmentBaseline: "central" as const,
  };
  return (
    <g pointerEvents="none">
      {isDali && (
        <g transform={`translate(${x - 6} ${y - 3.5})`}>
          <circle r={2} fill={badgeColor} stroke="none" />
          <text {...textStyle} x={0} y={0} fontSize={2.52}>D</text>
        </g>
      )}
      <C1_TagFunction x={x} y={y - 1.1} label={label} color={color} />
    </g>
  );
}
